import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './i18n'
import './index.css'
import App from './app/App'

// Measure the OS scrollbar width once and expose it as --sbw. Every .tab-scroll-area
// reserves a stable scrollbar gutter (constant width whether or not the scrollbar
// shows); its direct card/panel children are pulled right by --sbw so they line up
// with the tab separator regardless of scroll state (agent-studio.html:6530-6541).
// On overlay scrollbars --sbw is 0 (no-op).
;(function measureScrollbarWidth() {
  const probe = document.createElement('div')
  probe.style.cssText = 'position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll'
  document.body.appendChild(probe)
  const sbw = probe.offsetWidth - probe.clientWidth
  document.body.removeChild(probe)
  document.documentElement.style.setProperty('--sbw', `${sbw}px`)
})()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
